import { defineComponent as _defineComponent } from 'vue';
export default /*#__PURE__*/_defineComponent({
  __name: 'BIcon',
  props: {
    icon: {
      type: String,
      required: true
    }
  },
  emits: ['onClick'],
  setup: function setup(__props, _ref) {
    var emit = _ref.emit;
    var props = __props;
    var classIcon = computed(function () {
      return "icon--".concat(props.icon);
    });
    function onClick() {
      emit('onClick');
    }
    return {
      __sfc: true,
      props: props,
      emit: emit,
      classIcon: classIcon,
      onClick: onClick
    };
  }
});